
export default function isValidDateString(str) {
    let date = new Date(str)
    if (isNaN(date.getTime())) {
        return isValidDateString_DD_MM_YYYY_format(str)
    } else { 
        return !isNaN(date.getTime())
    }
   
}

function isValidDateString_DD_MM_YYYY_format(str) {
    // Match DD-MM-YYYY & DD/MM/YYYY
    const match = /^(\d{2})[-\/](\d{2})[-\/](\d{4})$/.exec(str)

    if (!match) return false
    const [ , day, month, year ] = match
    const date = new Date(`${year}-${month}-${day}`)
    return !isNaN(date.getTime())
}

